export class PatientEmailNotEqualsToInMvError extends Error {
  constructor() {
    super(
      'Você já possui um cadastro. Envie um e-mail de contato para a área de gestão de leitos do hospital: <Inserir email>'
    )
    this.name = 'PatientEmailNotEqualsToInMvError'
  }
}
